import { ref } from 'vue';
import ajax from '@/utils/Ajax';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useNotification } from '@shared/components/ui/notification';
import { useRegisterStore } from '@/stores/RegisterStore';

export function useVerConnectFunction() {
  const store = useGlobalStore();
  const registerStore = useRegisterStore();
  const { openNotBottom } = useNotification();
  const proofDialogValue = ref({
    open: false,
  });

  const connectCheck = async (item, key) => {
    let is_verifity = window.localStorage.getItem('CREATOR_PROTAL_is_verifity');
    if (is_verifity) {
      try {
        store.loading = true;
        const res = await ajax.post('/connect-social-account', { cache_key: key });
        const data = res.data.data;
        const isNewConnect = data.is_new_connect;
        const isOtherAccount = data.need_verify_motom ? data.verify_motom_code : false;

        const connectSuccess = async () => {
          await registerStore.spGetUserHandle();
          registerStore.step = '2-4';
        };

        if (isOtherAccount) {
          window.localStorage.setItem('CREATOR_PROTAL_verify_motom_code', isOtherAccount);
          proofDialogValue.value = { open: true };
        } else if (!isNewConnect) {
          openNotBottom(`This account is already connected`, 'error');
        } else if (window.localStorage.getItem('CREATOR_PROTAL_new_add_social')) {
          openNotBottom(`New social account added`, 'success');
          setTimeout(async () => {
            connectSuccess();
          }, 1000);
        } else {
          openNotBottom(`${item} connection successful`, 'success');
          setTimeout(async () => {
            connectSuccess();
          }, 1000);
        }

        window.localStorage.removeItem('CREATOR_PROTAL_new_add_social');
        window.localStorage.removeItem('CREATOR_PROTAL_is_more_social');
        window.localStorage.removeItem('CREATOR_PROTAL_is_verifity');

        registerStore.handleVerSocialPage();
      } catch (error) {
        if (error?.response?.data?.data?.message) {
          openNotBottom(`${error.response.data.data.message}`, 'error');
        } else {
          openNotBottom(`${item} connection not successful`, 'error');
        }

        registerStore.step = '2-3';
        window.localStorage.removeItem('CREATOR_PROTAL_new_add_social');
        window.localStorage.removeItem('CREATOR_PROTAL_is_more_social');
        window.localStorage.removeItem('CREATOR_PROTAL_is_verifity');
      } finally {
        store.loading = false;
      }
    }
  };

  const findConnect = async () => {
    try {
      let ig = JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_ig_social_key'));
      let tk = JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_tk_social_key'));
      let yt = JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_yt_social_key'));
      if (ig) {
        window.localStorage.removeItem('CREATOR_PROTAL_ig_social_key');
        connectCheck('Instagram', ig);
      } else if (tk) {
        window.localStorage.removeItem('CREATOR_PROTAL_tk_social_key');
        connectCheck('TikTok', tk);
      } else if (yt) {
        window.localStorage.removeItem('CREATOR_PROTAL_yt_social_key');
        connectCheck('YouTube', yt);
      }
    } catch (error) {
      window.localStorage.removeItem('CREATOR_PROTAL_motom_register_step');
    }
  };

  const findBindConnect = async () => {
    let verify_motom_code = window.localStorage.getItem('CREATOR_PROTAL_verify_motom_code');
    let cache_key = window.localStorage.getItem('CREATOR_PROTAL_login_cache_key');

    if (verify_motom_code) {
      store.loading = true;
      try {
        let formData = new FormData();
        formData.append('verify_motom_code', verify_motom_code);
        formData.append('cache_key', cache_key);
        await ajax.post('/bind-motom-account', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setTimeout(async () => {
          await registerStore.handleVerSocialPage();
        }, 1000);
        openNotBottom(`Binding account success.`, 'success');
      } catch (error) {
        if (error?.response?.data?.data?.message) {
          openNotBottom(`${error.response.data.data.message}`, 'error');
        } else {
          openNotBottom(`Binding account fail`, 'error');
        }
      } finally {
        store.loading = false;
        window.localStorage.removeItem('CREATOR_PROTAL_verify_motom_code');
        window.localStorage.removeItem('CREATOR_PROTAL_login_cache_key');
      }
    }
  };

  return {
    connectCheck,
    findConnect,
    proofDialogValue,
    findBindConnect,
  };
}
